import angular from 'angular';
import workbenchTask from './workbenchTask';
import './style.scss';

export default angular
  .module('components.workbenchTask', [])
  .component('workbenchTask', workbenchTask).name;
